import React, { useState } from 'react';
import { products, categories } from '../data/products';
import './Products.css';

const Products = () => {
  const [selectedCategory, setSelectedCategory] = useState('All');
  const [selectedProduct, setSelectedProduct] = useState(null);

  const filteredProducts = selectedCategory === 'All' 
    ? products 
    : products.filter(product => product.category === selectedCategory);

  return (
    <div className="products-page">
      <div className="products-hero">
        <div className="products-hero-content">
          <h1>Our Products</h1>
          <p>Premium quality cocopeat and coir products for all your agricultural needs</p>
        </div>
      </div>

      <div className="products-container">
        <div className="container">
          {/* Category Filter */}
          <div className="category-filter">
            {categories.map(category => (
              <button
                key={category}
                className={`category-btn ${selectedCategory === category ? 'active' : ''}`}
                onClick={() => setSelectedCategory(category)}
              >
                {category}
              </button>
            ))}
          </div>

          {/* Products Grid */}
          <div className="products-grid">
            {filteredProducts.map(product => (
              <div 
                key={product.id} 
                className="product-card"
                onClick={() => setSelectedProduct(product)}
              >
                <div className="product-image-wrapper">
                  <img 
                    src={product.image} 
                    alt={product.name}
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/400x300?text=' + encodeURIComponent(product.name);
                    }}
                  />
                  <div className="product-overlay">
                    <span className="view-details">View Details</span>
                  </div>
                </div>
                <div className="product-info">
                  <span className="product-category">{product.category}</span>
                  <h3 className="product-name">{product.name}</h3>
                  <p className="product-description-preview">
                    {product.description.substring(0, 100)}...
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Product Drawer */}
      {selectedProduct && (
        <>
          <div className="drawer-backdrop" onClick={() => setSelectedProduct(null)}></div>
          <div className="product-drawer">
            <button className="drawer-close" onClick={() => setSelectedProduct(null)}>
              ×
            </button>
            <div className="drawer-content">
              <div className="drawer-image">
                <img 
                  src={selectedProduct.image} 
                  alt={selectedProduct.name}
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/500x400?text=' + encodeURIComponent(selectedProduct.name);
                  }}
                />
              </div>
              <div className="drawer-info">
                <span className="drawer-category">{selectedProduct.category}</span>
                <h2 className="drawer-title">{selectedProduct.name}</h2>
                <div className="drawer-description">
                  <h4>Product Description</h4>
                  <p>{selectedProduct.description}</p>
                </div>
                <div className="drawer-actions">
                  <button className="btn btn-primary" onClick={() => setSelectedProduct(null)}>
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Products;

